
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { post } from '../helpers/api_helper';
import { POST_CREAT_ORDER, GET_UPDATE_ORDER } from '../helpers/url_helper';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const PaymentModal = forwardRef((props, ref) => {
    const { t } = useTranslation();

    const [orderInfo, SetOrderInfo] = useState({});

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [ThankMessage, SetThankMessage] = useState(false);

    const [form_inputs, setInputs] = useState({
        transactionId: '',
        orderId: 0,
        totalEmployees: 10,
        subscriptionType: '',
    });

    useImperativeHandle(ref, () => ({
        async openPaymentModel(planId, subscriptionType, totalEmployees, subscriptionId = 0) {
            form_inputs.transactionId = '';
            form_inputs.orderId = 0;
            setInputs({...form_inputs});

            SetThankMessage(false);
            SetButtonDisabled(true);

            var api_res = await post(POST_CREAT_ORDER, {
                planId: planId,
                subscriptionType: subscriptionType,
                totalEmployees: totalEmployees,
                subscriptionId : subscriptionId,
            });
            if (api_res.status) {

                const myModalEl = document.getElementById('paymentModal');
                new window.bootstrap.Modal(myModalEl).show();

                form_inputs.orderId = api_res.data.planInfo.orderId;
                setInputs({ ...form_inputs });

                SetOrderInfo(api_res.data.planInfo);
            } else {
                toast.error(api_res.message);
                props.call_back();
            }
            SetButtonDisabled(false);
        }

    }));

    const handleInputChange = (event) => {
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }

    const submit = async () => {
        if (!form_inputs.transactionId) {
            toast.error('Transaction id is required');
            return;
        }

        SetButtonDisabled(true);
        var res_data = await post(GET_UPDATE_ORDER, form_inputs);
        if (res_data.status) {
            SetThankMessage(true)
        } else {
            toast.error(res_data.message);
            props.call_back();
        }
        SetButtonDisabled(false);

    }

    return (
        <>
            <div className="modal fade" id="paymentModal" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <button type="button" className="btn btn-sm close modal-close d-none" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>

                        {ThankMessage && <>
                            <div className="modal-header">
                                <button type="button" style={{ "position": "absolute", "right": "-30px", "padding": "0px", "top": "0px" }} className="btn btn-sm close" onClick={() => {props.call_back()}} data-bs-dismiss="modal" aria-label="Close">
                                    <i className="bx bx-x" style={{ fontSize: "30px", "color": "#fff" }}></i>
                                </button>
                            </div>
                            <div className='modal-body'>
                                <div className='text-center'>
                                    <svg width={100} className='mb-4' viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#87d185" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"></path></g></svg>
                                    <div dangerouslySetInnerHTML={{ __html: t('homePage.transaction.paymentSuccess') }}></div>
                                </div>
                            </div>
                        </>}
                        {!ThankMessage && <>
                            <div className="modal-header">
                                <h5 className="mb-0">{orderInfo.name}</h5>
                                <p className='mb-0'>{t('homePage.transaction.orderNo')}. {orderInfo.orderId}</p>
                                <button type="button" style={{ "position": "absolute", "right": "-30px", "padding": "0px", "top": "0px" }} className="btn btn-sm close" onClick={() => {props.call_back()}} data-bs-dismiss="modal" aria-label="Close">
                                    <i className="bx bx-x" style={{ fontSize: "30px", "color": "#fff" }}></i>
                                </button>
                            </div>
                            <div className="modal-body pb-0">
                                <div className='text-center mb-3'>
                                    <img className='mb-4 border rounded' src={orderInfo.qr_code} alt='Qr code' />
                                    <p className='text-center'><small>{t('homePage.transaction.paymentInfo')}</small></p>
                                    <img src='/upi.png' width="200px" alt='upi icon' />
                                </div>

                            </div>
                            <div className="modal-footer">
                                <div className="input-group mb-3">
                                    <input type="text" onChange={handleInputChange} name='transactionId' value={form_inputs.transactionId} className="form-control" placeholder="Transaction Id" />
                                    <button onClick={submit} className="btn btn-primary" disabled={ButtonDisabled}> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('submit')}</button>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </>
    );
});

export default PaymentModal;